// Stylesheets
import "./theme.scss";
import "./resources/images/favicon.png";

const documentReadyFunctions = () => {

};

const runDocumentReadyFunctions = () => {
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    documentReadyFunctions();
  } else {
    requestAnimationFrame(runDocumentReadyFunctions);
  }
};

runDocumentReadyFunctions();
